import { Link } from "react-router-dom";
import {
  BookOpen, Sparkles, Gift, UserCircle, ShieldCheck, Upload, Users, Gavel,
  Server, Scale, ExternalLink, Lock, Copyright, RefreshCw, LogOut, Landmark, Mail,
} from "lucide-react";
import LegalShell from "@/components/LegalShell";

const SECTIONS = [
  {
    icon: BookOpen,
    title: "1. Geltungsbereich",
    paragraphs: [
      <>Diese Nutzungsbedingungen gelten für die Nutzung der App FestivalPlan sowie der dazugehörigen Website unter <a href="https://festivalplan.app" className="text-[#00E5FF]">https://festivalplan.app</a>.</>,
      "FestivalPlan wird von Sebastian Menzel betrieben.",
      "Mit der Registrierung eines Benutzerkontos oder der Nutzung von FestivalPlan akzeptierst du diese Nutzungsbedingungen.",
      "Wenn du mit diesen Bedingungen nicht einverstanden bist, darfst du FestivalPlan nicht nutzen.",
    ],
  },
  {
    icon: Sparkles,
    title: "2. Was ist FestivalPlan?",
    paragraphs: [
      "FestivalPlan ist eine kostenlose digitale Plattform zur gemeinsamen Planung und Organisation von Festivalbesuchen.",
      "Die App ermöglicht unter anderem:",
    ],
    list: [
      "die Erstellung und Verwaltung von Gruppen",
      "die gemeinsame Planung von Festivalbesuchen",
      "Gruppenchats",
      "Aufgaben- und To-do-Listen",
      "gemeinsame Einkaufs- und Packlisten",
      "Organisation von Fahrgemeinschaften",
      "Aufteilung und Verwaltung gemeinsamer Ausgaben",
      "das Teilen von Fotos und anderen Inhalten innerhalb von Gruppen",
      "das Erstellen und Teilen von Festivalrouten und Karten",
      "weitere Funktionen zur gemeinsamen Festivalplanung",
    ],
    after: ["Der konkrete Funktionsumfang kann jederzeit erweitert, verändert oder angepasst werden."],
  },
  {
    icon: Gift,
    title: "3. Kostenlose Nutzung",
    paragraphs: [
      "Die Nutzung von FestivalPlan ist grundsätzlich kostenlos.",
      "Für die Nutzung der App werden derzeit keine Abonnements oder kostenpflichtigen Premium-Funktionen angeboten.",
      "FestivalPlan behält sich vor, das Angebot zukünftig zu verändern oder gegebenenfalls weitere Funktionen anzubieten. Sollte für bestimmte Funktionen künftig ein Entgelt erforderlich sein, wird dies vor der Nutzung entsprechend kenntlich gemacht.",
    ],
  },
  {
    icon: UserCircle,
    title: "4. Registrierung und Benutzerkonto",
    paragraphs: [
      "Für bestimmte Funktionen ist die Erstellung eines Benutzerkontos erforderlich.",
      "Bei der Registrierung müssen die angegebenen Informationen korrekt und wahrheitsgemäß sein.",
      "Du bist dafür verantwortlich, deine Zugangsdaten vertraulich zu behandeln und dein Benutzerkonto vor dem Zugriff Dritter zu schützen.",
      "Wenn du feststellst, dass jemand unbefugt auf dein Konto zugreift oder Zugriff auf deine Zugangsdaten erhalten hat, solltest du FestivalPlan schnellstmöglich darüber informieren.",
      "Ein Benutzerkonto darf nicht auf andere Personen übertragen oder anderen Personen zur dauerhaften Nutzung überlassen werden.",
    ],
  },
  {
    icon: ShieldCheck,
    title: "5. Verhalten bei der Nutzung",
    paragraphs: ["FestivalPlan darf nur für rechtmäßige Zwecke genutzt werden.", "Insbesondere ist es nicht erlaubt:"],
    list: [
      "andere Nutzer zu beleidigen, zu bedrohen, zu belästigen oder zu diskriminieren",
      "rechtswidrige, gewaltverherrlichende, pornografische oder anderweitig unzulässige Inhalte zu verbreiten",
      "Inhalte zu veröffentlichen, die Rechte Dritter verletzen",
      "fremde Bilder, Texte, Videos oder andere Inhalte ohne entsprechende Berechtigung hochzuladen",
      "falsche Identitäten zu verwenden, um andere Personen zu täuschen",
      "FestivalPlan für Spam, Werbung oder unerwünschte Nachrichten zu missbrauchen",
      "Schadsoftware oder andere schädliche Inhalte zu verbreiten",
      "technische Sicherheitsmaßnahmen zu umgehen",
      "die App oder ihre Infrastruktur absichtlich zu stören oder zu überlasten",
      "automatisierte Zugriffe oder andere technische Verfahren einzusetzen, die den normalen Betrieb beeinträchtigen",
    ],
  },
  {
    icon: Upload,
    title: "6. Inhalte der Nutzer",
    paragraphs: [
      "Nutzer können innerhalb von FestivalPlan eigene Inhalte erstellen und teilen. Dazu können beispielsweise Nachrichten, Fotos, Texte, Aufgaben, Listen, Routen oder andere Informationen gehören.",
      "Du bist selbst dafür verantwortlich, dass die von dir hochgeladenen oder geteilten Inhalte rechtmäßig sind und keine Rechte anderer Personen verletzen.",
      "Du musst insbesondere sicherstellen, dass du über die erforderlichen Rechte verfügst, wenn du Fotos, Videos, Texte oder andere geschützte Inhalte hochlädst.",
      "Mit dem Hochladen von Inhalten gewährleistest du, dass du hierzu berechtigt bist.",
      "FestivalPlan erhält durch das Hochladen deiner Inhalte nur die Rechte, die erforderlich sind, um diese Inhalte innerhalb der vorgesehenen Funktionen der App zu speichern, zu verarbeiten und anderen von dir ausgewählten Nutzern zugänglich zu machen.",
      "Eine darüber hinausgehende Nutzung deiner Inhalte erfolgt nicht ohne entsprechende Rechtsgrundlage oder deine erforderliche Zustimmung.",
    ],
  },
  {
    icon: Users,
    title: "7. Inhalte anderer Nutzer",
    paragraphs: [
      "FestivalPlan stellt eine Plattform zur Verfügung, auf der Nutzer eigene Inhalte miteinander teilen können.",
      "FestivalPlan macht sich fremde Nutzerinhalte grundsätzlich nicht zu eigen.",
      "Wir können nicht garantieren, dass sämtliche von Nutzern bereitgestellten Informationen richtig, vollständig oder aktuell sind.",
      "Wenn dir ein rechtswidriger oder gegen diese Nutzungsbedingungen verstoßender Inhalt auffällt, kannst du dich über die auf der Website angegebenen Kontaktmöglichkeiten an uns wenden.",
    ],
  },
  {
    icon: Gavel,
    title: "8. Moderation und Sperrung",
    paragraphs: [
      "Bei einem Verstoß gegen diese Nutzungsbedingungen oder geltendes Recht kann FestivalPlan geeignete Maßnahmen ergreifen.",
      "Dazu können insbesondere gehören:",
    ],
    list: [
      "Entfernung einzelner Inhalte",
      "Einschränkung einzelner Funktionen",
      "vorübergehende Sperrung eines Benutzerkontos",
      "dauerhafte Sperrung eines Benutzerkontos",
      "Löschung eines Benutzerkontos",
    ],
    after: [
      "Bei der Entscheidung werden die Umstände des jeweiligen Einzelfalls berücksichtigt.",
      "Gesetzliche Rechte der Nutzer bleiben unberührt.",
    ],
  },
  {
    icon: Server,
    title: "9. Verfügbarkeit der App",
    paragraphs: [
      "Wir bemühen uns, FestivalPlan möglichst zuverlässig zur Verfügung zu stellen.",
      "Eine jederzeitige und unterbrechungsfreie Verfügbarkeit kann jedoch nicht garantiert werden.",
      "Insbesondere können vorübergehende Einschränkungen oder Ausfälle aufgrund von:",
    ],
    list: [
      "Wartungsarbeiten",
      "technischen Störungen",
      "Updates",
      "Problemen bei Drittanbietern",
      "Netzwerkausfällen",
      "höherer Gewalt",
      "Sicherheitsvorfällen",
    ],
    after: [
      "auftreten.",
      "Wir behalten uns vor, Funktionen vorübergehend einzuschränken, zu ändern oder einzustellen, soweit dies aus technischen, rechtlichen oder betrieblichen Gründen erforderlich ist.",
    ],
  },
  {
    icon: Scale,
    title: "10. Haftung",
    paragraphs: [
      "FestivalPlan wird mit der gebotenen Sorgfalt betrieben.",
      "Für Schäden haften wir nach den gesetzlichen Vorschriften.",
      "Die Haftung für Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit sowie für Schäden aufgrund vorsätzlichen oder grob fahrlässigen Verhaltens bleibt unberührt.",
      "FestivalPlan übernimmt keine Verantwortung für die Richtigkeit oder Vollständigkeit von Inhalten, die von anderen Nutzern erstellt oder geteilt werden.",
      "Insbesondere solltest du dich bei wichtigen Entscheidungen – beispielsweise bei Fahrgemeinschaften, Treffpunkten oder Festivalinformationen – nicht ausschließlich auf Angaben innerhalb der App verlassen.",
    ],
  },
  {
    icon: ExternalLink,
    title: "11. Externe Dienste und Links",
    paragraphs: [
      "FestivalPlan kann Funktionen oder Verknüpfungen enthalten, die auf Dienste oder Angebote Dritter verweisen.",
      "Für Inhalte, Verfügbarkeit und Datenschutzpraktiken externer Anbieter ist grundsätzlich der jeweilige Anbieter verantwortlich.",
      "Es gelten gegebenenfalls die jeweiligen Nutzungs- und Datenschutzbedingungen des Drittanbieters.",
    ],
  },
  {
    icon: Lock,
    title: "12. Datenschutz",
    paragraphs: [
      <>Informationen darüber, welche personenbezogenen Daten bei der Nutzung von FestivalPlan verarbeitet werden und zu welchen Zwecken dies erfolgt, findest du in unserer <Link to="/datenschutz" className="text-[#00E5FF]">Datenschutzerklärung</Link>.</>,
      "Die Datenschutzerklärung ist Bestandteil der Informationen zur Nutzung von FestivalPlan, stellt jedoch eine eigenständige rechtliche Information dar.",
    ],
  },
  {
    icon: Copyright,
    title: "13. Geistiges Eigentum",
    paragraphs: [
      "Die von FestivalPlan selbst bereitgestellten Inhalte, das Design, die Software, Logos, Grafiken, Texte und sonstigen Bestandteile der Plattform sind, soweit nicht anders angegeben, urheberrechtlich oder anderweitig rechtlich geschützt.",
      "Eine Nutzung, Vervielfältigung oder Verbreitung dieser Inhalte außerhalb der bestimmungsgemäßen Nutzung von FestivalPlan ist nur mit entsprechender Erlaubnis oder aufgrund einer gesetzlichen Erlaubnis zulässig.",
    ],
  },
  {
    icon: RefreshCw,
    title: "14. Änderungen der Nutzungsbedingungen",
    paragraphs: [
      "FestivalPlan kann diese Nutzungsbedingungen ändern, wenn dies aufgrund von Änderungen der App, technischen Entwicklungen, gesetzlichen Anforderungen oder anderen berechtigten Gründen erforderlich ist.",
      "Über wesentliche Änderungen werden Nutzer in geeigneter Weise informiert.",
      "Wenn du FestivalPlan nach Inkrafttreten der geänderten Nutzungsbedingungen weiter nutzt, gelten die geänderten Bedingungen, soweit dem keine zwingenden gesetzlichen Vorschriften entgegenstehen.",
    ],
  },
  {
    icon: LogOut,
    title: "15. Beendigung der Nutzung",
    paragraphs: [
      "Du kannst die Nutzung von FestivalPlan jederzeit beenden.",
      "Sofern die App eine entsprechende Funktion bereitstellt, kannst du dein Benutzerkonto direkt über die App löschen.",
      "Alternativ kannst du dich über die angegebenen Kontaktmöglichkeiten an uns wenden.",
      "Gesetzliche Aufbewahrungspflichten bleiben von einer Löschung unberührt.",
    ],
  },
  {
    icon: Landmark,
    title: "16. Anwendbares Recht",
    paragraphs: [
      "Es gilt das Recht der Bundesrepublik Deutschland, soweit dem keine zwingenden gesetzlichen Vorschriften entgegenstehen.",
      "Für Verbraucher gelten insbesondere die gesetzlichen Verbraucherschutzvorschriften des Staates, in dem der Verbraucher seinen gewöhnlichen Aufenthalt hat, soweit diese zwingend anwendbar sind.",
    ],
  },
  {
    icon: Mail,
    title: "17. Kontakt",
    paragraphs: [
      "Bei Fragen zu diesen Nutzungsbedingungen oder zur Nutzung von FestivalPlan kannst du uns über die auf unserer Website angegebenen Kontaktmöglichkeiten erreichen.",
    ],
    contact: true,
  },
];

export default function Nutzungsbedingungen() {
  return (
    <LegalShell testId="nutzungsbedingungen-page" eyebrow="Rechtliches" title="Nutzungsbedingungen">
      <div className="-mt-6">
        <p data-testid="nutzungsbedingungen-subtitle" className="text-base text-white/70 md:text-lg">
          Regeln und Informationen zur Nutzung von FestivalPlan
        </p>
        <p data-testid="nutzungsbedingungen-updated" className="mt-3 text-sm text-white/40">Stand: September 2026</p>
      </div>

      <div className="space-y-5">
        {SECTIONS.map((s, i) => <TermsSection key={s.title} index={i} {...s} />)}
      </div>

      <nav
        data-testid="nutzungsbedingungen-related-links"
        aria-label="Weitere rechtliche Informationen"
        className="mt-4 flex flex-wrap items-center gap-x-6 gap-y-3 border-t border-white/5 pt-8 text-sm"
      >
        <span className="text-white/40">Weitere Informationen:</span>
        {[
          { label: "Datenschutzerklärung", to: "/datenschutz" },
          { label: "Impressum", to: "/impressum" },
          { label: "Support", to: "/support" },
        ].map((l) => (
          <Link
            key={l.to}
            to={l.to}
            data-testid={`nutzungsbedingungen-link-${l.to.slice(1)}`}
            className="inline-flex min-h-[44px] items-center text-white/60 transition-colors hover:text-[#00E5FF]"
          >
            {l.label}
          </Link>
        ))}
      </nav>
    </LegalShell>
  );
}

function TermsSection({ icon: Icon, title, paragraphs = [], list, after = [], contact, index }) {
  return (
    <section
      data-testid={`terms-section-${index + 1}`}
      className="glass-card rounded-2xl p-6 sm:p-8"
    >
      <div className="mb-4 flex items-center gap-3.5">
        <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl border border-[#8B5CF6]/30 bg-[#8B5CF6]/10 text-[#00E5FF]">
          <Icon className="h-[18px] w-[18px]" aria-hidden="true" />
        </span>
        <h2 className="font-display text-lg font-semibold leading-snug text-white md:text-xl">{title}</h2>
      </div>
      <div className="space-y-3 text-[15px] leading-[1.75] text-white/65 sm:text-base">
        {paragraphs.map((p) => <p key={p}>{p}</p>)}
        {list && (
          <ul className="space-y-2 pl-1">
            {list.map((item) => (
              <li key={item} className="flex gap-3">
                <span className="mt-[11px] h-1.5 w-1.5 shrink-0 rounded-full bg-gradient-to-r from-[#8B5CF6] to-[#00E5FF]" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        )}
        {after.map((p, i) => <p key={`a${i}`}>{p}</p>)}
        {contact && (
          <div className="mt-2 rounded-xl border border-white/5 bg-white/[0.03] p-4 sm:p-5">
            <p className="font-display font-semibold text-white">FestivalPlan</p>
            <p>Betreiber: Sebastian Menzel</p>
            <p>
              Website:{" "}
              <a href="https://festivalplan.app" className="inline-flex min-h-[44px] items-center text-[#00E5FF]">
                https://festivalplan.app
              </a>
            </p>
            <p>
              E-Mail:{" "}
              <a href="mailto:support@festivalplan.app" data-testid="terms-contact-email" className="inline-flex min-h-[44px] items-center break-all text-[#00E5FF]">
                support@festivalplan.app
              </a>
            </p>
          </div>
        )}
      </div>
    </section>
  );
}
